import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginManager } from 'src/app/_managers/login-manager.services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private router: Router,
    private loginManager: LoginManager
) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    ///&& this.loginManager.isToken()!==1 && this.loginManager.isToken()!==undefined 
      if (this.loginManager.isLogin() && !this.loginManager.isLogin().error)  {
        return true;
      }
      this.loginManager.deleteToken();
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  
}
